import { Modal, Button, Col, Row } from "react-bootstrap";
import { modal } from "@/utils/constant";

function PlayAgainModal({ show, hide, loading, onContinue }) {
  return (
    <Modal
      show={show}
      onHide={() => !loading && hide()}
      dialogClassName="custom-game-modal"
      centered
    >
      <Modal.Header className="bg-secondary" closeButton={!loading}>
        <Modal.Title>
          {modal?.playAgainModalTitle}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-10 px-lg-12">
        <p className="mb-3">
          {modal?.playAgainModalIntro1}
        </p>
        <p className="mb-3">
          {modal?.playAgainModalIntro2}
        </p>
        <p className="mb-4">
          {modal?.playAgainModalIntro3}
        </p>
        <p className="fw-bold mb-2"><b>{modal?.playAgainModalHowItWorks}</b></p>
        <ul className="ps-3 mb-0">
          <li className="mb-1 mx-3">{modal?.playAgainModalBullet1}</li>
          <li className="mb-1 mx-3">{modal?.playAgainModalBullet2}</li>
          <li className="mb-1 mx-3">{modal?.playAgainModalBullet3}</li>
          <li className="mb-1 mx-3">{modal?.playAgainModalBullet4}</li>
          <li className="mb-1 mx-3">{modal?.playAgainModalBullet5}</li>
        </ul>
        <Row className="mt-8">
          <Col>
            <Button
              variant="secondary"
              className="font-semibold w-full"
              disabled={loading}
              onClick={onContinue}
            >
              {loading ? modal?.playAgainModalLoading : modal?.playAgainModalContinue}
            </Button>
          </Col>
          <Col>
            <Button
              variant="outline-primary"
              className="font-semibold w-full"
              disabled={loading}
              onClick={hide}
            >
              {modal?.cancle}
            </Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

export default PlayAgainModal;
